import { useEffect, useState } from "react";
import { ArrowRight, ShieldCheck, Boxes, ClipboardCheck, Layers3, LockKeyhole, MoveUpRight } from "lucide-react";
import { API, startSignIn } from "./auth";
import "./welcome.css";

export default function Welcome() {
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const response = await fetch(`${API}/auth/me`, { credentials: "include" });
        setAuthed(response.ok);
      } catch (e) {
        setAuthed(false);
      }
    };
    void check();
  }, []);

  const onSignIn = (e) => {
    e.preventDefault();
    if (authed) window.location.href = "/erp";
    else startSignIn();
  };

  return (
    <div className="welcome-page" data-testid="welcome-page">
      <header className="welcome-header">
        <a className="welcome-brand" href="/" aria-label="Rollcon ERP home">
          <img src="/rollcon-logo.jpeg" alt="Rollcon Engineering Company logo" />
          <span>ROLLCON<span className="welcome-brand-sub">ENTERPRISE RESOURCE PLANNING</span></span>
        </a>
        <span className="welcome-secure"><ShieldCheck size={16} /> A secure workspace for your team</span>
      </header>
      <main className="welcome-main">
        <section className="welcome-intro">
          <div className="welcome-eyebrow"><span /> BUILT FOR THE WAY YOU ENGINEER</div>
          <h1>Welcome to<br /><span>Rollcon ERP.</span></h1>
          <p className="welcome-description">Every project. Every component.<br />One connected workspace.</p>
          <p className="welcome-detail">Bring procurement, people, and progress together. From the first RFQ to the final receipt, keep your team moving with clarity.</p>
          <div className="welcome-login">
            <div className="welcome-login-title">
              <div className="welcome-login-icon"><LockKeyhole size={20} /></div>
              <div><h2>Your work starts here</h2><p>Access your assigned Rollcon workspace.</p></div>
            </div>
            <a className="welcome-signin" href="/erp" onClick={onSignIn} data-testid="welcome-signin-button">
              {authed ? "Open your workspace" : "Sign in to your workspace"}<ArrowRight size={18} />
            </a>
            <p className="welcome-signin-note">
              <ShieldCheck size={13} />
              {authed ? "Signed in securely · Access based on your role" : "Secure sign-in with Google · Access managed by your admin"}
            </p>
          </div>
          <div className="welcome-benefits">
            <span><ClipboardCheck size={16} /> Clear approvals</span>
            <span><Boxes size={16} /> Live procurement</span>
            <span><Layers3 size={16} /> Connected teams</span>
          </div>
        </section>
        <aside className="welcome-visual">
          <div className="visual-kicker"><span className="visual-number">01 /</span> THE CONNECTED FACTORY <span className="visual-cross">+</span></div>
          <div className="visual-heading"><h2>Precision in engineering.<br /><span>Clarity in operations.</span></h2><p>Purpose-built for Rollcon.</p></div>
          <div className="technical-drawing"><img className="coil-processing-image" src="/coil-processing-line.png" alt="Coil processing line with Rollcon blue and red machinery, including the uncoiler, feeder, press and conveyor" /></div>
          <div className="visual-caption"><span>COIL PROCESSING LINE</span><span>PRECISION AT EVERY STAGE ↗</span></div>
          <div className="visual-module"><div className="visual-module-icon"><Boxes size={22} /></div><div><span className="visual-phase">YOUR FIRST MODULE</span><h3>Procurement</h3><p>From RFQ to ready for production.</p></div><MoveUpRight size={22} /></div>
          <div className="visual-roadmap"><span><i className="active" />Procurement</span><span className="roadmap-line" /><span><i />Production</span><span className="roadmap-line" /><span><i />HR</span></div>
          <p className="visual-next">A foundation that grows with your business.</p>
        </aside>
      </main>
      <footer className="welcome-footer"><span>© {new Date().getFullYear()} Rollcon Engineering Company Private Limited</span><span>ENGINEERED TO WORK TOGETHER <span className="footer-red">—</span></span></footer>
    </div>
  );
}
